
module dg.objects {


    //interface IPeriodOptions {
    //    types?: Array<number>;
    //    years: Array<string>;
    //    quarters: Array<string>;
    //    months: Array<string>;
    //}

    export interface IPeriod {
        type?: dg.domain.model.PeriodType;
        year?: string,
        month?: string,
        quarter?: string
    };

    //export enum DG_PERIOD_TYPE {
    //    month = 0,
    //    quarter = 1,
    //    year = 2
    //}

    export class PeriodService {

        options = {
            years: [],
            quarters: ['Q1', 'Q2', 'Q3', 'Q4'],
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        }

        public getPeriodOptions() {
            let currentYear = new Date().getFullYear();
            if (this.options.years[this.options.years.length - 1] != currentYear.toString()) {
                this.options.years = [];
                let baseYear = 2017;
                for (let i = baseYear; i <= currentYear; i += 1) {
                    this.options.years.push(i.toString());
                }
            }

            return this.options;
        }

        public convertToClient(value: dg.domain.model.Period): IPeriod {
            let result: IPeriod = {
                type: null,//dg.domain.model.PeriodType.Year,
                year: null,
                month: null,
                quarter: null
            }

            if (value && value.value) {

                let arr = value.value.split('-');

                result.type = value.type;
                result.year = arr[0];

                if (value.type == "Month") {
                    result.month = this.options.months[parseInt(arr[1]) - 1];
                } else if (value.type == "Quarter") {
                    result.quarter = this.options.quarters[parseInt(arr[1]) - 1];
                }
            }

            return result;
        }

        public checkValidity(period: IPeriod) {

            if (!period
                || !period.year
                || (period.type == "Quarter" && !period.quarter)
                || (period.type == "Month" && !period.month)
            ) {
                return false;
            }

            return true;
        }
        public convertToServer(period: IPeriod): dg.domain.model.Period {
            if (!this.checkValidity(period)) {
                return null;
            }

            let formattedValue = period.year;

            let options = this.getPeriodOptions();

            if (period.type === "Month" && period.month) {
                formattedValue += '-' + (options.months.indexOf(period.month) + 1);
            } else if (period.type === "Quarter" && period.quarter) {
                formattedValue += '-' + (options.quarters.indexOf(period.quarter) + 1);
            }

            let result: dg.domain.model.Period = {
                type: period.type,
                value: formattedValue,
                domainType: "Period"
            }

            return result;
        }

        public stringifyValue(value: IPeriod) {
            let formattedString: string;

            if (value.year) {
                formattedString = value.year;
                if (value.type == "Month" && value.month) {
                    formattedString = value.month + ' ' + formattedString;
                } else if (value.type == "Quarter" && value.quarter) {
                    formattedString = value.quarter + ' ' + formattedString;
                }
            }

            return formattedString;
        }

    }
    angular.module('dg.objects')
        .service('periodService', PeriodService);
}